var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-header',{attrs:{"showStyle":"white"}}),_c('div',{staticClass:"bg-box"},[_c('div',{staticClass:"wrap contain-box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }